import { type ReactNode, useState } from "react";

import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import { Tag } from "common/components/ui/Tag";
import { formatDate } from "common/helpers/utils";

import ClientActions from "../ClientActions";
import ClientActionsDropdown from "../ClientActionsDropdown";

import type { AgencyClient } from "../../../types";

interface MobileDrawerContentProps {
  client: AgencyClient;
}

function DetailItem({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex px-4 justify-between border-b border-b-black-200 py-2 items-center">
      <span className="flex text-button-sm">{label}</span>
      {children}
    </div>
  );
}

export default function MobileClientDetails({
  client,
}: MobileDrawerContentProps) {
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [action, setAction] = useState<"remove" | "edit">();

  const {
    first_name: firstName,
    last_name: lastName,
    email,
    created_at: createdAt,
  } = client;

  return (
    <>
      <div className="flex pl-16 pr-4 py-3 border-b border-b-black-200 gap-x-2 lg:gap-x-2.5 items-start">
        <div className="flex gap-x-3 items-start flex-1">
          <AimfoxAvatar firstName={firstName} lastName={lastName} size="md" />
          <div className="flex flex-col gap-y-1">
            <span className="text-sm-bold">
              {firstName} {lastName}
            </span>
            <p className="text-black-500 text-xs-medium">{email}</p>
          </div>
        </div>
        <ClientActionsDropdown
          setAction={(selectedAction) => {
            setAction(selectedAction);
            setIsActionOpen(true);
          }}
        />
      </div>

      <DetailItem label="Role">d</DetailItem>
      <DetailItem label="Added">
        <Tag variant="tertiary">{formatDate(createdAt)}</Tag>
      </DetailItem>
      <DetailItem label="Status">d</DetailItem>

      <Drawer open={isActionOpen} onOpenChange={setIsActionOpen}>
        <DrawerContent>
          <ClientActions
            action={action}
            client={client}
            onClose={() => setIsActionOpen(false)}
          />
        </DrawerContent>
      </Drawer>
    </>
  );
}
